import React, { useState } from 'react';
import '../../App.css';
import './CoffeeRoaster.css';
import Footer from '../Footer';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const colorImages = {
    white: [
        '/images/silver roaster.JPG',
        '/images/white4.JPG',
        '/images/white2.JPG',
        '/images/white3.JPG',
    ],
    black: [
        '/images/black3.JPG',
        '/images/black1.JPG',
        '/images/black2.JPG',
    ],
};

export default function CoffeeRoaster() {
    const [selectedColor, setSelectedColor] = useState('white');
    const [activeIndex, setActiveIndex] = useState(0);

    const images = colorImages[selectedColor];

    // Colors currently out of stock
    const OUT_OF_STOCK = { black: true };
    const isOutOfStock = !!OUT_OF_STOCK[selectedColor];

    const handleColorChange = (color) => {
        setSelectedColor(color);
        setActiveIndex(0);
    };

    const goLeft = () => {
        setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goRight = () => {
        setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <>
            <div className='equip-page'>
                <div className='equip-container'>
                    {/* Left: Image Gallery */}
                    <div className='equip-gallery'>
                        <div className='equip-main-image'>
                            <button className='equip-arrow equip-arrow-left' onClick={goLeft}>
                                <FaChevronLeft />
                            </button>
                            <img src={images[activeIndex]} alt={`The Box - ${selectedColor}`} />
                            <button className='equip-arrow equip-arrow-right' onClick={goRight}>
                                <FaChevronRight />
                            </button>
                        </div>
                        <div className='equip-thumbnails'>
                            {images.map((img, idx) => (
                                <div
                                    key={idx}
                                    className={`equip-thumb ${idx === activeIndex ? 'equip-thumb-active' : ''}`}
                                    onClick={() => setActiveIndex(idx)}
                                >
                                    <img src={img} alt={`Thumbnail ${idx + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right: Product Info */}
                    <div className='equip-info'>
                        <h1 className='equip-product-name'>The Box</h1>
                        <p className='equip-product-subtitle'>Premium handcrafted coffee roaster</p>
                        <p className='equip-product-price'>$350 <span className='equip-currency'>USD</span></p>

                        <div className='equip-color-section'>
                            <span className='equip-color-label'>
                                Color: {selectedColor === 'white' ? 'Silver' : 'Black'}
                                {isOutOfStock && <span className='equip-oos-tag'> — Out of Stock</span>}
                            </span>
                            <div className='equip-color-options'>
                                <div
                                    className={`equip-color-swatch equip-swatch-white ${selectedColor === 'white' ? 'equip-swatch-selected' : ''}`}
                                    onClick={() => handleColorChange('white')}
                                    title='Silver'
                                />
                                <div
                                    className={`equip-color-swatch equip-swatch-black equip-swatch-oos ${selectedColor === 'black' ? 'equip-swatch-selected' : ''}`}
                                    onClick={() => handleColorChange('black')}
                                    title='Black — Out of Stock'
                                />
                            </div>
                        </div>

                        <button
                            className='equip-preorder-btn'
                            disabled={isOutOfStock}
                            onClick={() => window.location.href = `mailto:info@offftheroast.com?subject=Pre-Order: The Box (${selectedColor === 'white' ? 'Silver' : 'Black'})&body=Hi, I'd like to pre-order The Box in ${selectedColor === 'white' ? 'Silver' : 'Black'}. Please send me more details.`}
                        >
                            {isOutOfStock ? 'OUT OF STOCK' : 'EMAIL US TO PRE-ORDER NOW'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Craftsman Section */}
            <div className='craftsman-section'>
                <div className='craftsman-container'>
                    <div className='craftsman-label'>
                        <span>MEET THE CRAFTSMAN</span>
                    </div>
                    <div className='craftsman-content'>
                        <div className='craftsman-text'>
                            <h2>NITI</h2>
                            <p>
                                Based in Songkhla, Thailand, Niti views coffee roasting as more than a mechanical process—it is a pursuit of beauty. Driven by a lifelong passion for the perfect cup, Niti has spent years refining a coffee roaster that balances technical mastery with aesthetic grace.
                            </p>
                            <p>
                                When you use a Niti-crafted roaster, you aren't just roasting coffee; you are engaging with a functional sculpture designed to deliver excellence, batch after batch.
                            </p>
                        </div>
                        <div className='craftsman-image'>
                            <img src='/images/Niti.JPG' alt='Niti - The Craftsman' />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
